import * as React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useGetPublicRequestForProposalByIdQuery } from 'proposals/requestForProposal/queries/useRequestForProposalQuery'
import RequestForProposalDownloadPdf from 'proposals/requestForProposal/RequestForProposalDownloadPdf'
import View from 'proposals/components/layout/View'
import ViewHeader from './ViewHeader'
import RequestForProposalBasicInfo from 'proposals/requestForProposal/RequestForProposalBasicInfo'
import { ViewLayout } from './ViewLayout'
import PublicRequestForProposalParticipateContainer from 'proposals/requestForProposal/PublicRequestForProposalParticipateContainer'
import ProposeFormContainer from '../ProposeFormContainer'
import { RequestForProposalStatus } from 'proposals/requestForProposal/requestForProposalConstants'

const LoadingContainer = styled('div')(() => ({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }))

  const PublicRequestForProposalView: React.FC = () => {
    const { uniqueToken } = useParams<{ uniqueToken: string }>()
    
    const { data: requestForProposal, isLoading, isError } = useGetPublicRequestForProposalByIdQuery(uniqueToken as string, {
        enabled: !!uniqueToken
    })


    if (isLoading) {
        return (
            <LoadingContainer>
                <CircularProgress />
            </LoadingContainer>
        )
    }

    if (isError) {
        return <Navigate to="/error" replace />
      }

    return (
        <View>
            <ViewLayout>
                <ViewHeader title={requestForProposal!.title} logoUrl={requestForProposal!.tenantLogoUrl} />
                <Box sx={{ gridArea: 'info', mt: 2 }}>
                    <RequestForProposalBasicInfo data={requestForProposal!} />
                    <RequestForProposalDownloadPdf uniqueToken={requestForProposal!.uniqueToken} rfpTitle={requestForProposal!.title} />
                </Box>
                <Box sx={{ gridArea: 'side-function', mt: 2 }}>
                    <PublicRequestForProposalParticipateContainer uniqueToken={requestForProposal!.uniqueToken} />
                </Box>
                <ProposeFormContainer
                    fields={requestForProposal!.fields}
                    recipient={null}
                    hasPropose={false}
                    isClosed={requestForProposal!.status === RequestForProposalStatus.CLOSED}
                    recipientCompany={null}
                    rfpLang={requestForProposal!.language}
                    region={''}
                    isPreview={true}
                />
            </ViewLayout>
        </View>
    )
}

export default PublicRequestForProposalView